// extracted by mini-css-extract-plugin
export default {"userReaction":"JoinCard_userReaction__tB9Yr","infoIcon":"JoinCard_infoIcon__tNlFa","tooltip":"JoinCard_tooltip__Me2B5"};